module.exports = __webpack_public_path__ + "static/media/logo-black.64f12bd4.svg";